
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sort'
})
export class SortPipe implements PipeTransform {

  transform(inputArray: Array<any>, sortBy: string)
  : any {
    let result = [...inputArray.sort()];
    if (sortBy === 'desc'){
      result = result.reverse();
    }
    return result;
  }
}



// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/app/shared/pipes/sort.pipe.ts